import React, { ReactNode, useState } from "react";

import Modal from "../Modal/Modal";
import { GeneralPlayer } from "../CleoPlayer/GeneralPlayer";
// import { getVideoIdFromUrl } from '../Create/utils';
// import GeneralPlayerWrapper from '../../../../../../apps/slike-cms/src'

interface Props {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  touched?: boolean;
  label: string;
  showRequired?: boolean;
  characterLimit?: number;
  disabled?: boolean;
  type?: string;
  className?: string;
  icon?: string;
  helperText?: string;
}

export const InputWithVideoPreview: React.FC<Props> = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  touched,
  showRequired,
  label,
  characterLimit,
  disabled,
  type = "text",
  className,
  icon,
  helperText,
  ...props
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalContent, setModalContent] = useState<React.ReactNode | null>(
    null
  );
  const [isValidId, setIsValidId] = useState<boolean>(false);

  const [inputText, setInputText] = useState<string>("");

  const handleChange = (e: any) => {
    setInputText(e.target.value);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setModalContent(null);
    setModalTitle("");
  };
  const handleShowPreview = () => {
    if (!value) return;
    setModalTitle("VIDEO PREVIEW");
    setIsModalOpen(true);
    setModalContent(<RenderModalComponent videoId={value} />);
  };

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={modalTitle}
          height="auto"
          width="770px"
        >
          {modalContent}
        </Modal>
      )}
      <div className={`position-relative ${className}`}>
        <div className="d-flex align-items-center gap-1 p-1">
          <label>{label}</label>
          {showRequired && <span className="required mr-2">*</span>}
        </div>
        <div className="input-group">
          {icon && (
            <span className="input-group-text bg-transparent border-end-0">
              <i className={`bi bi-${icon}`}></i>
            </span>
          )}
          <input
            type={type}
            className={`form-control ${error && touched ? "is-invalid" : ""}`}
            name={name}
            value={value}
            onChange={(e) => {
              handleChange(e);
              onChange(e);
            }}
            onBlur={onBlur}
            placeholder={placeholder}
            style={{ height: "38px" }}
            disabled={disabled}
            {...props}
          />
          <span
            className="input-group-text pointer"
            onClick={handleShowPreview}
          >
            <i className="bi bi-play fs-12 pointer"></i>
          </span>
          {helperText && <div className="form-text">{helperText}</div>}
        </div>

        {touched && error && (
          <div className="form-text text-danger px-2 position-absolute">
            {error}
          </div>
        )}
      </div>
    </>
  );
};

//TODO Have to replace this with Actual ID
const RenderModalComponent = ({ videoId }: { videoId: string }) => {
  return (
    <div style={{ height: "33.75vw", width: "auto" }}>
      <GeneralPlayer
        id="embed"
        remoteConfig={true}
        playerType="yt"
        videoData={{
          mid: videoId,
        }}
      />
    </div>
  );
};

export default InputWithVideoPreview;
